var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../cache/node/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75b5df09","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../cache/node/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/flexbox/flexbox-item.vue
// module id = null
// module chunks = 